import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";

import { useNavigate } from "react-router-dom";
import { EditCoachDetails } from "../../../../api/AuthenticationServices";
const EditCoach = (props) => {
  const location = useLocation();
  const coachDetails = location.state?.coachRow;
  console.log("Some Data", coachDetails);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const initialValues = {
    coFirstName: coachDetails.firstname,
    coLastName: coachDetails.lastname,
    coDescription: coachDetails.description,
    coPhnNumber: coachDetails.phnNumber,
    coEmailId: coachDetails.email,
    coId: coachDetails.id,
  };

  const sendData = async (e, values) => {
    // console.log("Form Submit Values", values);

    console.log(values);
    e.preventDefault();
    const data = {
      coFirstName: values.coFirstName,
      coLastName: values.coLastName,
      coDescription: values.coDescription,
      coPhnNumber: values.coPhnNumber,
      coEmailId: values.coEmailId,
      coId: coachDetails.id,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
      },
    };
    // console.log("DAta Player : ", data);
    // console.log("Before AddNew Plafer");
    try {
      const res = await EditCoachDetails(data, config);

      if (res.data.status === "success") {
        // console.log("Inside Successs");
        alert(res.data.message);
        navigate("/admin/viewcoaches");
      } else {
        if (res.data.status === "") {
          alert(res.data.message);
          navigate("/admin/viewcoaches");
        }
      }
    } catch (e) {
      //FIX : Message of error need to be shown to user Only Axios Error Displaying
      alert(e);
      navigate("admin/viewcoaches");
    }
  };
  return (
    <div>
      <Box m="20px">
        <Header
          title="EDIT COACH DETAILS"
          subtitle="Update the fields of coach"
        />

        <Formik
          // onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            // console.log(values,handleChange)
            <form onSubmit={(e) => sendData(e, values)}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="First Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.coFirstName}
                  name="coFirstName"
                  error={!!touched.coFirstName && !!errors.coFirstName}
                  helperText={touched.coFirstName && errors.coFirstName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Last Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.coLastName}
                  name="coLastName"
                  error={!!touched.coLastName && !!errors.coLastName}
                  helperText={touched.coLastName && errors.coLastName}
                  sx={{ gridColumn: "span 2" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Coach Email Id"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.coEmailId}
                  name="coEmailId"
                  error={!!touched.coEmailId && !!errors.coEmailId}
                  helperText={touched.coEmailId && errors.coEmailId}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Description"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.coDescription}
                  name="coDescription"
                  error={!!touched.coDescription && !!errors.coDescription}
                  helperText={touched.coDescription && errors.coDescription}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Contact Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.coPhnNumber}
                  name="coPhnNumber"
                  error={!!touched.coPhnNumber && !!errors.coPhnNumber}
                  helperText={touched.coPhnNumber && errors.coPhnNumber}
                  sx={{ gridColumn: "span 4" }}
                />
              </Box>
              {/* <button type="submit">asdasd</button> */}
              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  disabled={false}
                  color="secondary"
                  variant="contained"
                >
                  Update Coach
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </div>
  );
};

const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

const checkoutSchema = yup.object().shape({
  coFirstName: yup.string().required("required"),
  coLastName: yup.string().required("required"),

  coEmailId: yup.string().email("invalid email").required("required"),
  coDescription: yup.string().required("required"),
  coPhnNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
});

export default EditCoach;
